/**
 * Initializes the Discover Uni charts
 *
 */
$(function() {

    if (!window.unistatsData) {
        return;
    }

    const colors = [
        'rgba(200, 11, 111, 0.8)',
        'rgba(1, 182, 237, 0.8)',
        'rgba(255, 221, 0, 0.8)',
    ];

    let charts = [];

    $.each(window.unistatsData, function(interval, stage) {
        $.each(stage, function(statName, data) {
            let chartSelector = `#${statName}_${interval}`,
                textSelector = `#${statName}_${interval}_text`,
                chartCanvas = $(chartSelector).get(0),
                legendFontSize = ($(window).width() > 520) ? 12 : 10,
                labels = $.map(data, function(value, key) {
                    return `${key}: ${value}%`;
                }),
                values = $.map(data, function(value, key) {
                    return value;
                }),
                total = values.reduce(function(a, b) {
                    return a + b;
                }, 0);

            let chartSettings = {
                type: 'doughnut',
                data: {
                    labels: labels,
                    datasets: [{
                        data: values,
                        backgroundColor: colors,
                    }],
                },
                options: {
                    legend: {
                        position: 'bottom',
                        labels: {
                            fontSize: legendFontSize,
                        },
                    },
                    tooltips: {
                        callbacks: {
                            label: function(tooltipItem, data) {
                                return data.labels[tooltipItem.index];
                            },
                        },
                    },
                },
            };

            if (total === 0) {
                chartSettings.data = {
                    labels: $.map(data, function(value, key) {
                        return `${key}: N/A`;
                    }),
                    datasets: [{
                        data: $.map(data, function(value, key) {
                            return 100 / values.length * 100;
                        }),
                        backgroundColor: $.map(data, function(value, key) {
                            return 'rgba(0, 0, 0, 0.15)';
                        }),
                    }],
                };
            }

            charts.push(new Chart(chartCanvas, chartSettings));

            $(textSelector).hide();
        });
    });

    $(window).resize(function(){
        let legendFontSize = ($(window).width() > 520) ? 12 : 10;
        $.each(charts, function(i, chart) {
            chart.options.legend.labels.fontSize = legendFontSize;
        });
    });

});
